import { Module, Lesson, Section } from '@/lib/types'; 
import { StripePrice } from '@/types'; 
import { EnrollmentButton } from "./EnrollmentButton";

interface EnrollmentSectionProps {
  course: {
    is_free: boolean;
    slug?: string;
    title?: string;
    default_price?: StripePrice | null; 
    modules?: Module[];
    course_type?: 'multi-lesson' | 'single-page';
    sections?: Section[];
  };
  userId: string | undefined;
  hasAccess: boolean;
  setHasAccess: (hasAccess: boolean) => void;
  lang: string;
  setAuthModalOpen: (isOpen: boolean) => void;
}

export function EnrollmentSection({ 
  course, 
  userId, 
  hasAccess, 
  setHasAccess,
  lang,
  setAuthModalOpen
}: EnrollmentSectionProps) {
  // Simple centered button - no card, no extra styling
  return (
    <div className="flex justify-center my-8">
      <EnrollmentButton
        course={course}
        userId={userId}
        hasAccess={hasAccess}
        setHasAccess={setHasAccess}
        lang={lang}
        setAuthModalOpen={setAuthModalOpen}
      />
    </div>
  );
}
